import { DeepKeyof, language } from "../../../traductions";

const traduction = {
  it: {
    title: {
      title: "Hai un’idea o vuoi conoscerci meglio?",
      subtitle:
        "In alternativa possiamo giocare a calcio balilla o fare una partita di ping pong in ufficio. Abbiamo anche una macchina per fare le granite. Insomma, contattaci per qualsiasi cosa, no televendite però.",
      button: "Sentiamoci!",
    },
    mailSection: {
      title: "Iscriviti alla newsletter",
      description:
        "Niente Spam! Di tanto in tanto condivideremo con te articoli del nostro blog, playlist, foto e aneddoti sulla vita in ufficio.",
      placeholder: "La tua email",
      successMsg1: "Grazie per l’iscrizione!",
      successMsg2: "Ci sentiremo presto, intanto controlla la mail.",
      errorMsg: "Qualcosa è andato storto. Riprova.",
      privacyConsent1: "Inserendo il tuo indirizzo confermi di aver letto la ",
      privacyConsent2:
        " e ci dai il permesso di aggiornarti via email per le finalità di marketing descritte nell’informativa.",
    },
    gridSection: {
      header1: "Company",
      header1List1: "Home",
      header1List2: "Manifesto",
      header1List3: "Progetti",
      header1List5: "Blog",
      header1List6: "Careers",
      header1List4: "Life @Mabiloft",
      header1List7: "Contatti",
      header2: "Events",
      header2List1: "Gingerbit",
      header2List2: "JavaSpritz",
      header2List3: "UXTea",
      header3: "Follow us",
      header3List1: "Instagram",
      header3List2: "LinkedIn",
      header3List3: "Facebook",
      header3List4: "Medium",
      header4: "Get in touch",
      header4List1: "hello@mabiloft.com",
      header4List2: "+39 0495221132",
      header5: "Where we are",
      header5List1: "Via Cadorna 2, Albignasego Padova, 35020 Italia",
    },
    policySection: {
      copyright: " - Mabiloft SRL - P.IVA 05157070284 - C.SOCIALE €10.000 I.V.",
      privacy: "Privacy policy",
      cookies: "Cookies policy",
    },
    adsButton: {
      buttonTxt: "Contattaci",
    },
  },
  en: {
    title: {
      title: "Any idea or do you want to know us better?",
      subtitle:
        "Otherwise we can play table football or have a ping-pong match in the office. We have a slush machine, too. Well, contact us for anything, except for telemarketing.",
      button: "Let's talk!",
    },
    mailSection: {
      title: "Subscribe to the newsletter",
      description:
        "No Spam! Once in a while we will share blog articles, playlists, photos and stories about our office life.",
      placeholder: "Your email",
      successMsg1: "Thanks for subscribing!",
      successMsg2: "We'll be in touch, in the meanwhile check your mail.",
      errorMsg: "Something went wrong. Try again.",
      privacyConsent1: "By sharing your email address you are agreeing on our ",
      privacyConsent2:
        " and allowing us to update you for marketing purposes as described in the policy.",
    },
    gridSection: {
      header1: "Company",
      header1List1: "Home",
      header1List2: "Manifesto",
      header1List3: "Projects",
      header1List5: "Blog",
      header1List6: "Careers",
      header1List4: "Life @Mabiloft",
      header1List7: "Contacts",
      header2: "Events",
      header2List1: "Gingerbit",
      header2List2: "JavaSpritz",
      header2List3: "UXTea",
      header3: "Follow us",
      header3List1: "Instagram",
      header3List2: "LinkedIn",
      header3List3: "Facebook",
      header3List4: "Medium",
      header4: "Get in touch",
      header4List1: "hello@mabiloft.com",
      header4List2: "+39 0495221132",
      header5: "Where we are",
      header5List1: "Via Cadorna 2,\tAlbignasego Padova,\t35020 Italia",
    },
    policySection: {
      copyright:
        " - Mabiloft SRL - VAT number 05157070284 - Share capital €10.000",
      privacy: "Privacy policy",
      cookies: "Cookies policy",
    },
    adsButton: {
      buttonTxt: "Contact us",
    },
  },
};

export const l_footer = (
  trad: DeepKeyof<(typeof traduction)[keyof typeof traduction]>
) => {
  const tokens = trad.split(".");
  let resource = traduction && (traduction as any)[language.code];
  if (!resource) {
    return tokens[tokens.length - 1];
  }

  for (let c = 0; c < tokens.length; c++) {
    resource = resource[tokens[c]];
    if (!resource) {
      return trad;
    }
  }

  return resource;
};
